import { type ContentOperation, ContentOperationStatus } from '../types';
import { isContentOperationExpired } from './isContentOperationExpired';

/**
 * Return true if the operation is considered still active and blocking.
 */
export function isContentOperationActive(operation: ContentOperation) {
    if (
        operation.status === ContentOperationStatus.SUCCESS ||
        operation.status === ContentOperationStatus.ERROR
    ) {
        return false;
    }

    return !isContentOperationExpired(operation);
}
